import { render, staticRenderFns } from "./DapLogo.vue?vue&type=template&id=a11620b2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a11620b2')) {
      api.createRecord('a11620b2', component.options)
    } else {
      api.reload('a11620b2', component.options)
    }
    module.hot.accept("./DapLogo.vue?vue&type=template&id=a11620b2&", function () {
      api.rerender('a11620b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/DapLogo.vue"
export default component.exports